import platform from "platform";
import type { MouseEvent } from "react";
import { browserVersion, isMacOs } from "react-device-detect";

/**
 * @deprecated Please use `react-device-detect` instead.
 */
const parseUserAgent = () => {
  const { name, version, os, description, product, layout, manufacturer, ua } =
    platform;

  // Note: making this redundant on purpose
  // to showcase available data.
  return {
    name,
    version,
    os,
    description,
    product,
    layout,
    manufacturer,
    ua,
  };
};

/**
 * @deprecated Please use `react-device-detect` instead.
 */
export const isSafari = () => parseUserAgent().name === "Safari";

/**
 * @deprecated Please use `react-device-detect` instead.
 */
export const isIphone = () => parseUserAgent().product === "iPhone";

export const isIntendedOnNewTab = (event?: MouseEvent<HTMLElement> | null) => {
  if (!event) return false;

  const isCtrlPressed = event.ctrlKey || event.metaKey;
  const isMiddleMouseClick = event.button && event.button === 1;

  return isCtrlPressed || isMiddleMouseClick;
};

export const isSafariMontereyOrOlder = () =>
  isSafari() && isMacOs && parseFloat(browserVersion) <= 15;
